import React from "react";
import { useRuleGroupRemovalMutation } from "../../../../api/ruleGroups.api";
import { TransactionRuleGroup } from "../../../../common/types/transactionRule";
import { ConfirmationModal } from "../../../general/ConfirmationModal";
import { useToaster } from "../../../general/ToastMessages/useToaster";

interface DeleteRuleGroupModalProps {
    ruleGroup: TransactionRuleGroup | null;
    onHide: () => void;
}

export const DeleteRuleGroupModal: React.FC<DeleteRuleGroupModalProps> = ({
    ruleGroup,
    onHide,
}) => {
    const toaster = useToaster();

    const { mutate: deleteRuleGroup } = useRuleGroupRemovalMutation(
        ruleGroup!,
        {
            onSuccess: () => {
                toaster.toast(
                    `Rule group "${ruleGroup?.name}" was deleted successfully.`,
                );
                onHide();
            },
            onError: (error) => {
                if (error.message) {
                    toaster.error(error.message);
                } else {
                    toaster.error(
                        "Failed to delete rule group. It might be a default group or contain rules.",
                    );
                }
            },
        },
    );

    if (!ruleGroup) {
        return null;
    }

    return (
        <ConfirmationModal
            title="Delete Rule Group"
            question={
                <>
                    <p>
                        Are you sure you want to delete the rule group "
                        {ruleGroup.name}"?
                    </p>
                    <p>
                        This action cannot be undone. Default rule groups and
                        groups containing rules cannot be deleted.
                    </p>
                </>
            }
            yes="Delete"
            no="Cancel"
            yesBtnVariant="danger"
            onConfirm={() => deleteRuleGroup()}
            onReject={onHide}
            show={true}
            onHide={onHide}
        />
    );
};
